<div class="pure-g header">
  <div class="description pure-u-1-2">
    {{pageData ? pageData.description : ''}}
  </div>
  <div class="create pure-u-1-2">
    <button class="pure-button button-success button-xlarge" *ngIf="pageData && pageData.methods && pageData.uploadFile && pageData.methods.put && (uploadFile || pageData.OnboardFile)" (click)="onClickEdit()">Upload File</button>
  </div>
</div>

<div class="create pure-u-1-2" *ngIf="pageData?.id == 'updateTransitTime' && queryParams.length != 1" >
  <button mat-raised-button color="blue" (click)="firstRequest()">Go Back To Choice Page</button>
  <br><br>
</div>

<app-loader [loading]="loading" [size]="'small'"></app-loader>

<div *ngIf="!loading">

  <form *ngIf="queryParams.length" class="pure-form pure-form-stacked" [formGroup]="queryForm" (ngSubmit)="getResults()">
    <fieldset>
      <field-input [field]="field" [form]="queryForm" [requestHeaders]="requestHeaders"
                  *ngFor="let field of queryParams"
                  class="pure-control-group">
      </field-input>

      <div class="pure-controls">
          <button type="submit" class="pure-button pure-button-primary" [disabled]="queryForm.invalid">Submit</button>
      </div>
    </fieldset>
  </form>

  <form *ngIf="filterableFields.length" class="pure-form form-group filter-form" #filterForm="ngForm">
    <fieldset>
      <input type="text" placeholder="Filter" class="form-control pure-input-1" [(ngModel)]="filterText" name="filterText"/>
    </fieldset>
  </form>

  <table class="pure-table pure-table-horizontal">
    <thead>
    <tr>
      <th *ngFor="let field of fields">{{field.label || field.name}}</th>
      <th *ngIf="showActions()" [ngStyle]="{width: '110px', textAlign: 'center'}">Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of (data | rowFilter:filterableFields:filterText)">
      <td *ngFor="let field of fields" [ngClass]="{'truncate': field.truncate}">
        <div [ngSwitch]="field.type">
          <ng-template [ngSwitchCase]="'text'" ngSwitchDefault>
            <div style="white-space:pre-wrap; word-wrap:break-word"> {{dataPathUtils.extractDataFromResponse(row, field.dataPath, field.name)}} </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'url'">
            <div *ngIf="extractFieldUrl(field, dataPathUtils.extractDataFromResponse(row, field.dataPath, field.name)); else elseBlock">
              <a target="_blank" href="{{extractFieldUrl(field, dataPathUtils.extractDataFromResponse(row, field.dataPath, field.name))}}">
                {{field.href}}
              </a>
            </div>
            <ng-template #elseBlock>
              NA
            </ng-template>
          </ng-template>
          <ng-template [ngSwitchCase]="'image'">
            <div class="thumb" [ngStyle]="{backgroundImage: 'url(' + dataPathUtils.extractDataFromResponse(row, field.dataPath, field.name) + ')'}"></div>
          </ng-template>
          <ng-template [ngSwitchCase]="'colorbox'">
            <div class="colorbox" [style.color]="'ForestGreen'" *ngIf="row.details.fileStatus != 'Active'">
              {{dataPathUtils.extractDataFromResponse(row, field.dataPath, field.name)}}
            </div>
            <div class="colorbox" [style.color]="'Crimson'" [style.font-weight]="'bolder'" [style.text-decoration]="'underline'" *ngIf="row.details.fileStatus == 'Active'">
              {{dataPathUtils.extractDataFromResponse(row, field.dataPath, field.name)}}
            </div>
          </ng-template>
        </div>
      </td>
      <td *ngIf="showActions()" [ngStyle]="{textAlign: 'center'}">
        <div class="pure-button-group">
          <button class="pure-button" [ngClass]="{hide: !pageData.methods.put}" (click)="onClickEdit(row)">
            {{actionsHeader}}
          </button>
          <button class="pure-button" [ngClass]="{hide: !pageData.methods.delete}" (click)="delete(row)">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

</div>
